import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import './style.scss';

const CallbackSuccess = () => {
  const { formatMessage } = useIntl();

  return (
    <div className="callback-success">
      <div className="callback-success__content">
        <FontAwesomeIcon
          icon={faCheckCircle}
          size="4x"
          className="callback-success__icon"
        />
        <h4 className="callback-success__message">
          {formatMessage({
            id: 'callbackSuccess.message',
            defaultMessage: 'Talebiniz alınmıştır, teşekkür ederiz.'
          })}
        </h4>
        <p className="callback-success__closing">
          {formatMessage({
            id: 'callbackSuccess.closing',
            defaultMessage: 'Bu pencereyi istediğiniz zaman kapatabilirsiniz.'
          })}
        </p>
      </div>
    </div>
  );
};

export default CallbackSuccess;
